import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * 合并 className，后写覆盖先写（含 Tailwind 冲突合并）
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
